import { useRouter } from 'next/router';

import { FormField, FormHelp, Label, Select } from '@zillow/constellation-10';

import { useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { useScreenSize } from '../../../hooks';
import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { usePropertyEditMutation } from '../../../hooks/usePropertyEditMutation';
import { bedOptions } from '../../../constants/ListingDetailsConstants';

const BedroomsFormField = () => {
  const router = useRouter();
  const { isScreenDesktop } = useScreenSize();

  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const floorPlans = listingDetails?.floorPlans || [];
  const floorPlanId = floorPlans[0]?.id;
  const initialBedrooms = floorPlans[0]?.numBedrooms;

  let bedOptionsValues = bedOptions;

  if (initialBedrooms !== undefined) {
    bedOptionsValues = bedOptions.slice(1);
  }

  const updateMutation = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms,
    meta: { context: { api: 'RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms' } },
  });

  const bedroomsField = useFieldSave({
    fieldName: 'bedrooms',
    initialValue: initialBedrooms,
    mutation: updateMutation,
    buildMutationVariables: (value) => (floorPlanId ? { postData: { floorPlanId, numBedrooms: Number(value) } } : null),
  });

  return (
    <FormField
      data-testid="BedroomsFormField"
      required={true}
      label={<Label>Total bedrooms</Label>}
      control={
        <Select
          size={isScreenDesktop ? 'lg' : 'md'}
          name="bedrooms"
          value={String(bedroomsField.value)}
          onChange={(e) => bedroomsField.onChange(Number(e.target.value))}
          onBlur={bedroomsField.onBlur}
        >
          {bedOptionsValues.map((option) => {
            if (option === 'studio') {
              return (
                <option key={option} value={0}>
                  {option}
                </option>
              );
            }
            return (
              <option key={option} value={option} disabled={option === ''}>
                {option || 'Select'}
              </option>
            );
          })}
        </Select>
      }
      error={!!bedroomsField.error}
      description={<FormHelp>{bedroomsField.error}</FormHelp>}
    />
  );
};

export default BedroomsFormField;
